const DirectDownloadActionTypes = {
    SAVE_DOWNLOAD_IDS: 'SAVE_DOWNLOAD_IDS',

    QUERY_DOWNLOAD_IDS_START: 'QUERY_DOWNLOAD_IDS_START',
    QUERY_DOWNLOAD_IDS_SUCCESS: 'QUERY_DOWNLOAD_IDS_SUCCESS',
    QUERY_DOWNLOAD_IDS_FAILED: 'QUERY_DOWNLOAD_IDS_FAILED',

    UPDATE_DOWNLOAD_IDS: 'UPDATE_DOWNLOAD_IDS'
}
export default DirectDownloadActionTypes 